import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2'
import { Router } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'app-details-view',
    templateUrl: './details-view.component.html',
    styleUrls: ['./details-view.component.css'],
    standalone: false
})
export class DetailsViewComponent implements OnInit {
  token: any;
  id: any;
  appointment: any;

  note: any[] = [];
  staffs: any[] = [];
  package: any = null;

  notes = {
    diagnosis: null,
    description: null
  }

  edit_notes = {
    diagnosis: null,
    description: null
  }

  rooms: any[] = [
    { 'room_001': 'Tratment Room 1' },
    { 'room_002': 'Tratment Room 2' },
    { 'room_003': 'Tratment Room 3' },
    { 'room_004': 'Tratment Room 4' },
    { 'adult_gym': 'Adults Gym' },
    { 'swim_pool': 'Swimming Pool' },
    { 'paeds_gym': 'Paeds Gym' },
    { 'overbooked': 'Overbooked Room' },
    { 'home_visit': 'Home visiting' },
    { 'home_visit_ob': 'Home visiting (OB)' }
  ];

  hijama = ['hijama', 'Cupping therapy ( dry)', 'Cupping therapy (Medicine)']

  note_id: any;
  Swal = 'sweetalert2';

  payment = {
    appointment_id: null,
    client_id: null,
    final_price: 0,
    final_price_to_pay: 0,
    service_price: 0,
    payment_details: null,
    payment_type: 'CARD'
  }

  services: any[] = [];
  service = {
    id: null,
    service_name: null,
    service_price: 0,
    final_price: 0,
    quantity: 1,
    recommended_by: null
  }

  items: any[] = [];
  item = {
    id: null,
    service_name: null,
    service_price: 0,
    final_price: 0,
    quantity: 1,
    recommended_by: null
  }

  payment_details: any[] = [];
  payment_services: any[] = [];
  sub_appointments: any[] = [];
  history: any[] = [];

  payment_services_clicked: boolean = false;

  doctors: any[] = [];
  savingAppointment = false;
  clinicianOnLeave = false;
  leaveCheckPending = false;
  private leaveCheckTimer: any;
  private leaveRequest = 0;
  private lastLeaveAlertKey = '';
  appointmentStatuses = ['PENDING', 'CONFIRMED', 'COMPLETED', 'MISSED', 'CANCELLED'];

  editAppointment = {
    date: '',
    doctor_id: null as any,
    recommended_by: null as any,
    service_id: null as any,
    service_name: null as string | null,
    service_price: 0,
    final_price: 0,
    period: 30,
    room: null as any,
    status: 'PENDING'
  };

  filter_config: any;

  eidt_package = {
    full_price: 0
  }

  constructor(public utility: UtilitiesService, public api: ApiService, public datepipe: DatePipe, private modalService: NgbModal, private router: Router, public common: CommonService) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
    this.id = localStorage.getItem('id');
    this.filter_config = {
      itemsPerPage: 1000,
      currentPage: 1,
      totalItems: 0,
      sort: null,
      sort_order: 'asc',
      pageSizeOptions: [5, 10, 25, 100]
    };
  }

  ngOnInit(): void {
    let item = localStorage.getItem('appointment');
    if (item) {
      this.appointment = JSON.parse(item);
      if (this.appointment) {
        this.applyPatientAge();
        this.getNotes();
        this.get_sub_appointments(this.appointment.appointment.id);
      }
    }
  }

  open(content: any) {
    this.modalService.open(content);
  }

  async open_invocie_modal(content: any) {
    if (this.utility.isDisabled(this.appointment?.appointment.service_name, this.hijama)) {
      Swal.fire({
        title: 'Please enter number of Hijama Cups',
        input: 'number',
        inputValue: 1,
        showCancelButton: true,
        inputLabel: 'Number of cups',
        allowOutsideClick: false
      }).then(result => {
        if (result.isDenied) {
          this.modalService.dismissAll();
        }
        if (result.isConfirmed) {
          let number_of_cups = +result.value;
          //this.invoice.quantity = number_of_cups;

          let payment_item = {
            service_name: this.appointment.appointment.service_name,
            service_price: this.appointment.appointment.service_price,
            final_price: +this.appointment.appointment.service_price * +number_of_cups,
            quantity: number_of_cups
          }

          if (this.payment_services.length > 0) {
            this.payment_services.forEach((item) => {
              if (item.service_name === payment_item.service_name) {
                this.payment.final_price -= +item.final_price;
                this.payment.final_price_to_pay -= +item.final_price;
                item.final_price = +payment_item.service_price * +payment_item.quantity;
                item.quantity = payment_item.quantity;
                this.payment.final_price += +payment_item.final_price;
                this.payment.final_price_to_pay += +payment_item.final_price;
              }
            });
          }

          if (!this.payment_services_clicked) {
            //this.payment.service_price = this.appointment.appointment.service_price;
            this.payment.final_price += +payment_item.final_price;
            this.payment.final_price_to_pay += +payment_item.final_price;

            this.payment.service_price = this.payment.final_price;

            this.payment_services.push(payment_item);
            this.payment_services_clicked = true;
          }

          this.modalService.open(content);
        }
      });
    }
    else {
      let payment_item = {
        service_name: this.appointment.appointment.service_name,
        service_price: this.appointment.appointment.service_price,
        final_price: this.appointment.appointment.final_price,
        quantity: 1
      }

      if (!this.payment_services_clicked) {
        if (this.appointment.appointment.has_pacakge) {
          this.payment.final_price += (+this.package.full_price - +this.package.paied_amount);
          this.payment.final_price_to_pay += (+this.package.full_price - +this.package.paied_amount);
        }
        else {
          this.payment.final_price += +this.appointment.appointment.final_price;
          this.payment.final_price_to_pay += +this.appointment.appointment.final_price;
        }

        this.payment.service_price = this.appointment.appointment.service_price;

        this.payment_services.push(payment_item);
        this.payment_services_clicked = true;
      }

      this.modalService.open(content);
    }
  }

  edit(content: any, note: any) {
    this.edit_notes = note;
    this.note_id = note.id;

    this.modalService.open(content);
  }

  getHttpParams() {
    let params = new HttpParams();
    params = params.append('page', this.filter_config.currentPage.toString());
    params = params.append('per_page', this.filter_config.itemsPerPage.toString());
    if (this.filter_config.sort) {
      params = params.append('sort', this.filter_config.sort);
      params = params.append('sort_order', this.filter_config.sort_order);
    }
    if (this.filter_config.queries) {
      params = params.append('queries', this.filter_config.queries);
    }
    return params;
  }

  /*
  * get services start */
  getNotes() {
    this.utility.loading = true;
    const sub = this.api.get('notes/open/appointment/' + this.appointment.appointment.id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.note = objects.notes;
      },
      async error => { }
    );

    sub.add(() => { this.getPatientPackges() });
  }

  // get package by id
  getPatientPackges() {
    if (this.appointment.appointment.has_pacakge) {
      const sub = this.api.get('package_patients/patient/' + this.appointment.appointment.patient_id + '/package/' + this.appointment.appointment.package_id, this.token).subscribe(
        async data => {
          let objects: any = {}
          objects = data;

          if (objects) this.package = objects;
          else this.package = null;
        },
        async error => { }
      );

      sub.add(() => { this.getServices(); });
    }
    else {
      this.getServices();
    }
  }

  getServices() {
    const sub = this.api.get('services/', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.services = objects;
      },
      async error => { }
    );
    sub.add(() => { this.getItems(); });
  }

  getItems() {
    const sub = this.api.get('items/', this.token, { params: this.getHttpParams() }).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.items = objects.items;
      },
      async error => { }
    );
    sub.add(() => { this.getStaffs(); });
  }

  getStaffs() {
    const sub = this.api.get('employees/active', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.staffs = objects;

        this.staffs.filter(i => i.name != 'Amal');
      },
      async error => { }
    );
    sub.add(() => { this.getHistory(); });
  }

  getHistory() {
    if (this.appointment.appointment.patient_package_id) {
      const sub = this.api.get('appointments/history/' + this.appointment.appointment.patient_package_id, this.token).subscribe(
        async data => {
          let objects: any = {}
          objects = data;
          this.history = objects.appointments;

          // check last apppointments notes ..
          let currentDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd HH:mm');
          let appointmentDate = this.datepipe.transform(this.appointment.appointment.date, 'yyyy-MM-dd HH:mm');

          if (currentDate && appointmentDate)
            if (appointmentDate > currentDate && !this.utility.isAllowed(['admin', 'accountant']) && this.appointment.appointment.status !== 'COMPLETED') {
              this.history.forEach((item) => {
                if (item.note_count == 0) {
                  Swal.fire({
                    title: 'Info',
                    text: 'You have appointments without colsed notes, Please add your notes before opening new appointment!',
                    icon: 'info',
                    confirmButtonText: 'Ok'
                  });
                  this.router.navigate(['appointments']);
                  return;
                }
              });
            }
        },
        async error => { }
      );
      sub.add(() => { this.utility.loading = false; });
    }
    else {
      this.utility.loading = false;
    }
  }
  /*
  * get services end */

  get_doctor_name(id: any) {
    const raw = localStorage.getItem('doctors');
    if (!raw) return '';
    const doctors = JSON.parse(raw);
    return doctors?.find((i: { id: any; }) => i.id === id)?.name ?? '';
  }

  getPrice() {
    if (this.service.id != null) {
      let service = this.services.find(i => i.id === this.service.id);

      this.service.service_price = service?.price;
      this.service.final_price = service?.price;
      this.service.service_name = service?.name;
    }
  }

  getItemPrice() {
    if (this.item.id != null) {
      let item = this.items.find(i => i.id === this.item.id);
      let left_quantity = +item.quantity - +item.paid_quantity;

      if (+left_quantity > 0) {
        this.item.service_price = item?.price;
        this.item.final_price = item?.price;
        this.item.service_name = item?.name;
      }
      else {
        Swal.fire({
          title: 'No Stock!',
          text: 'No quantity left for this item!',
          icon: 'warning'
        });
        this.item.id = null;
      }
    }
  }

  add_service() {
    if (this.service.id) {
      // Create a copy of the service object to avoid reference issues
      const serviceCopy = { ...this.service };

      this.payment.final_price += +serviceCopy.final_price;
      this.payment.final_price_to_pay += +serviceCopy.final_price;
      this.payment.service_price += +serviceCopy.final_price;

      // Push the copied service object into the arrays
      this.payment_details.push(serviceCopy);
      this.payment_services.push(serviceCopy);

      this.modalService.dismissAll();
    }
  }

  add_item() {
    if (this.item.id) {
      // Create a copy of the item object to avoid reference issues
      const itemCopy = { ...this.item };

      this.payment.final_price += +itemCopy.final_price;
      this.payment.final_price_to_pay += +itemCopy.final_price;
      this.payment.service_price += +itemCopy.final_price;

      // Push the copied item object into the arrays
      this.payment_details.push(itemCopy);
      this.payment_services.push(itemCopy);

      this.modalService.dismissAll();
    }
  }

  removeService(serviceToRemove: any) {
    const indexDetails = this.payment_details.findIndex(
      (service) => service.id === serviceToRemove.id
    );
    const indexServices = this.payment_services.findIndex(
      (service) => service.id === serviceToRemove.id
    );

    // Remove from payment_details if found
    if (indexDetails !== -1) {
      this.payment_details.splice(indexDetails, 1);
    }

    // Remove from payment_services if found
    if (indexServices !== -1) {
      this.payment_services.splice(indexServices, 1);
    }

    // Adjust payment totals
    this.payment.final_price -= +serviceToRemove.final_price;
    this.payment.final_price_to_pay -= +serviceToRemove.final_price;
    this.payment.service_price -= +serviceToRemove.final_price;
  }


  // add note
  async OnSumbit() {
    const body = {
      title: this.appointment.appointment.service_name,
      description: this.notes.description,
      diagnosis: this.notes.diagnosis,
      details: [],
      patient_id: this.appointment.patient.id,
      appointment_id: this.appointment.appointment.id,
      doctor_id: this.appointment.appointment.doctor_id,
      user_id: this.id
    }

    const sub = this.api.post("notes/", body, this.token).subscribe(
      async data => {
        Swal.fire({
          title: 'Success!',
          text: 'Created Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    sub.add(() => { this.getNotes(); this.modalService.dismissAll(); });
  }

  // update note
  async OnUpdate(id: any) {
    const body = {
      description: this.edit_notes.description,
      diagnosis: this.edit_notes.diagnosis,
    }

    const sub = this.api.update("notes/" + id, body, this.token).subscribe(
      async data => {
        Swal.fire({
          title: 'Success!',
          text: 'Created Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    sub.add(() => { this.getNotes(); this.modalService.dismissAll(); });
  }

  // delete note
  OnDelete(id: any) {
    Swal.fire({
      title: 'Do you want to delete this Note?',
      showCancelButton: true,
      icon: 'question',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        const sub = this.api.delete('notes/' + id, this.token).subscribe(
          async data => {
            Swal.fire({
              title: 'Success!',
              text: 'Deleted Successfuly!',
              icon: 'success',
              confirmButtonText: 'Cool'
            })
          },
          async error => {
            Swal.fire({
              title: 'Error!',
              text: 'Something went wrong!',
              icon: 'error',
              confirmButtonText: 'Ok'
            });
          }
        );

        sub.add(() => { this.getNotes(); });
      }
    });
  }

  get serviceLocked(): boolean {
    const item = this.appointment?.appointment;
    return !!(item?.payment_id || item?.has_pacakge);
  }

  get editPeriodRangeLabel(): string {
    const minutes = Number(this.editAppointment?.period);
    if (!this.editAppointment?.date || !minutes || minutes <= 0) {
      return '';
    }
    const start = new Date(this.editAppointment.date);
    if (Number.isNaN(start.getTime())) {
      return '';
    }
    const end = new Date(start.getTime() + minutes * 60 * 1000);
    const clock = (value: Date) => value.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    return `${clock(start)} to ${clock(end)}`;
  }

  openEditAppointment(content: any) {
    const item = this.appointment?.appointment;
    if (!item) {
      return;
    }

    const raw = localStorage.getItem('doctors');
    this.doctors = raw ? JSON.parse(raw) : [];
    if (this.appointment?.doctor && !this.doctors.some((doctor: any) => doctor.id === this.appointment.doctor.id)) {
      this.doctors = [this.appointment.doctor, ...this.doctors];
    }
    this.loadDoctors();
    if (item.recommended_by && !this.staffs.some((staff: any) => staff.id === item.recommended_by)) {
      this.staffs = [{
        id: item.recommended_by,
        name: this.get_doctor_name(item.recommended_by) || 'Current staff'
      }, ...this.staffs];
    }

    this.editAppointment = {
      date: this.toDatetimeLocal(item.date),
      doctor_id: item.doctor_id,
      recommended_by: item.recommended_by,
      service_id: item.service_id,
      service_name: item.service_name,
      service_price: Number(item.service_price) || 0,
      final_price: Number(item.final_price) || 0,
      period: Number(item.period) || 30,
      room: item.room,
      status: item.status || 'PENDING'
    };

    this.modalService.open(content, { size: 'lg' });
    this.scheduleLeaveCheck();
  }

  onEditClinicianChange(): void {
    this.scheduleLeaveCheck();
  }

  onEditDateChange(): void {
    this.scheduleLeaveCheck();
  }

  private scheduleLeaveCheck(): void {
    clearTimeout(this.leaveCheckTimer);
    const doctorId = this.editAppointment?.doctor_id;
    const start = this.editAppointment?.date ? new Date(this.editAppointment.date) : null;
    const requestId = ++this.leaveRequest;
    if (!doctorId || !start || Number.isNaN(start.getTime())) {
      this.clinicianOnLeave = false;
      this.leaveCheckPending = false;
      this.lastLeaveAlertKey = '';
      return;
    }
    this.leaveCheckPending = true;
    this.leaveCheckTimer = setTimeout(() => this.checkClinicianLeave(requestId, start), 300);
  }

  private checkClinicianLeave(requestId: number, start: Date): void {
    const doctorId = this.editAppointment?.doctor_id;
    if (requestId !== this.leaveRequest || !doctorId) {
      return;
    }
    const params = new HttpParams().set('date', this.editAppointment.date);
    this.api.get('leaves/employee/' + doctorId + '/on', this.token, { params }).subscribe(
      (data: any) => {
        if (requestId !== this.leaveRequest) {
          return;
        }
        this.leaveCheckPending = false;
        this.clinicianOnLeave = !!data?.on_leave;
        if (!this.clinicianOnLeave) {
          this.lastLeaveAlertKey = '';
          return;
        }
        const key = `${doctorId}|${this.datepipe.transform(start, 'yyyy-MM-dd')}`;
        if (this.lastLeaveAlertKey === key) {
          return;
        }
        this.lastLeaveAlertKey = key;
        this.showClinicianLeaveAlert(data, start);
      },
      () => {
        if (requestId !== this.leaveRequest) {
          return;
        }
        this.leaveCheckPending = false;
        this.clinicianOnLeave = false;
      }
    );
  }

  private showClinicianLeaveAlert(leave: any, start: Date): void {
    const doctor = this.doctors.find(item => item.id === this.editAppointment.doctor_id);
    const name = leave?.employee_name || doctor?.name || 'This clinician';
    const when = this.datepipe.transform(start, 'dd MMM yyyy, h:mm a');
    const hours = Number(leave?.hours);
    const hoursText = hours > 0 && hours < 8 ? ` (${hours} hours)` : '';
    Swal.fire({
      title: 'Clinician on leave',
      text: `${name} is on leave at this time (${when})${hoursText}. Choose another date or another clinician.`,
      icon: 'warning',
      confirmButtonText: 'Ok'
    });
  }

  loadDoctors() {
    this.api.get('employees/role/doctor', this.token).subscribe(
      async data => {
        const objects: any = data;
        const list = Array.isArray(objects) ? objects : [];
        if (this.appointment?.doctor && !list.some((doctor: any) => doctor.id === this.appointment.doctor.id)) {
          list.unshift(this.appointment.doctor);
        }
        if (list.length) {
          this.doctors = list;
        }
      }
    );
  }

  onEditServiceChange() {
    if (this.serviceLocked || this.editAppointment.service_id == null) {
      return;
    }
    const service = this.services.find(i => i.id === this.editAppointment.service_id);
    if (!service) {
      return;
    }
    this.editAppointment.service_name = service.name;
    this.editAppointment.service_price = Number(service.price) || 0;
    this.editAppointment.final_price = Number(service.price) || 0;
  }

  updateAppointment() {
    const item = this.appointment?.appointment;
    if (!item || this.savingAppointment) {
      return;
    }

    const start = new Date(this.editAppointment.date);
    if (this.clinicianOnLeave) {
      this.showClinicianLeaveAlert(
        { employee_name: this.doctors.find(item => item.id === this.editAppointment.doctor_id)?.name },
        start
      );
      return;
    }
    if (!this.editAppointment.date || Number.isNaN(start.getTime())) {
      Swal.fire({
        title: 'Warning!',
        text: 'Please enter a valid appointment date!',
        icon: 'warning',
        confirmButtonText: 'Ok'
      });
      return;
    }
    if (start.getHours() < 9) {
      Swal.fire({
        title: 'Warning!',
        text: 'No appointments before 9AM!',
        icon: 'warning',
        confirmButtonText: 'Ok'
      });
      return;
    }

    const body = {
      date: this.editAppointment.date,
      period: Number(this.editAppointment.period),
      doctor_id: this.editAppointment.doctor_id,
      recommended_by: this.editAppointment.recommended_by,
      patient_id: item.patient_id,
      service_id: this.editAppointment.service_id,
      service_name: this.editAppointment.service_name,
      service_price: this.editAppointment.service_price,
      final_price: this.editAppointment.final_price,
      room: this.editAppointment.room,
      status: this.editAppointment.status
    };

    this.savingAppointment = true;
    const sub = this.api.update('appointments/' + item.id, body, this.token).subscribe(
      async () => {
        Swal.fire({
          title: 'Success!',
          text: 'Appointment updated successfully!',
          icon: 'success',
          confirmButtonText: 'Ok'
        });
        this.modalService.dismissAll();
        this.get_appointment_id(item.id);
      },
      async error => {
        if (error.status == 405) {
          Swal.fire({
            title: 'Warning!',
            text: 'This room is booked for this time. Please choose a different time or room.',
            icon: 'warning',
            confirmButtonText: 'Ok'
          });
        } else {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      }
    );

    sub.add(() => { this.savingAppointment = false; });
  }

  private toDatetimeLocal(value: string): string {
    if (!value) {
      return '';
    }
    return String(value).replace(' ', 'T').slice(0, 16);
  }

  private applyPatientAge() {
    const birthDate = this.appointment?.patient?.birth_date;
    if (!birthDate || Number.isNaN(Date.parse(birthDate))) {
      return;
    }
    const dob: any = new Date(birthDate);
    const today: any = new Date();
    const timediff = Math.abs(today - dob);
    this.appointment.patient.age = Math.floor((timediff / (1000 * 3600 * 24)) / 365);
  }

  onDeleteAppointment(item: any) {
    Swal.fire({
      title: 'Do you want to delete this appointment?',
      showCancelButton: true,
      icon: 'question',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        this.api.delete('appointments/' + item.id, this.token).subscribe(
          async data => {

          },
          async error => {
            Swal.fire({
              title: 'Error!',
              text: 'Something went wrong!',
              icon: 'error',
              confirmButtonText: 'Ok'
            });
          }
        );
      }
    })
  }

  is_hidden(appointment: any) {
    if (appointment.status === 'COMPLETED')
      return true;

    return false
  }

  is_hidden_appointment(appointment: any) {
    if (appointment.payment_id)
      return true;
    return false
  }


  calculate_service() {
    this.service.final_price = this.service.service_price * this.service.quantity;
  }

  calculate_item() {
    this.item.final_price = this.item.service_price * this.item.quantity;
  }

  create() {
    if (this.note.length > 0 || this.utility.isAllowed(['admin', 'accountant'])) {
      let details: any = {
        payment_services: null,
        package: null,
      }

      details.payment_services = this.payment_services;

      if (this.appointment.appointment.has_pacakge) {
        this.package.no_sessions_took = +this.package.no_sessions_took + 1;
        this.package.no_sessions_left = +this.package.no_sessions_left - 1;

        let difference = +this.payment.final_price - +this.payment.final_price_to_pay;
        let package_left = +this.package.full_price - +this.package.paied_amount;

        this.package.paied_amount = +this.package.paied_amount + (package_left - difference);

        details.package = this.package;

        this.payment.service_price = this.payment.final_price_to_pay;
      }

      let patient = {
        patient_name: `${this.appointment.patient.first_name} ${this.appointment.patient.last_name}`,
        patient_number: this.appointment.patient.patient_number,
        patient_phone: this.appointment.patient.phone,
        patient_address: this.appointment.patient.address
      }

      details.patient = patient;

      let doctor = {
        doctor_name: this.appointment.doctor.name,
        visiting_reason: this.appointment.appointment.service_name
      }

      details.doctor = doctor;

      let body = {
        appointment_id: this.appointment.appointment.id,
        client_id: this.appointment.appointment.patient_id,
        final_price: this.payment.final_price_to_pay,
        service_price: this.payment.service_price,
        payment_type: this.payment.payment_type,
        is_package: this.appointment.appointment.has_pacakge,
        package_paid_amount: this.appointment.appointment.has_pacakge ? this.package.paied_amount : 0,
        payment_details: details
      }

      const sub = this.api.post("payments/", body, this.token).subscribe(
        async data => {
          this.update_item_quantity();

          // success message ...
          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'success',
            title: 'Payment Created Successfully'
          })

          let objects: any = {}
          objects = data;

          let id = objects.id;

          await this.delay(2200);
          this.router.navigate([]).then(result => { window.open('invoice_print?id=' + id, '_blank'); });
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );

      sub.add(() => { this.modalService.dismissAll(); });
    } else {
      Swal.fire({
        title: 'Info',
        text: 'Please add your notes before creating the invoice!',
        icon: 'info',
        confirmButtonText: 'Ok'
      });
      this.modalService.dismissAll();
    }
  }

  update_item_quantity() {
    if (this.item.id) {
      let body = {
        'paid_quantity': +this.item.quantity
      }

      const sub = this.api.update("items/quantity/" + this.item.id, body, this.token).subscribe(
        async data => {
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong updating stock!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );

      sub.add(() => { this.create_sub_appointment(); });
    }
    else
      this.create_sub_appointment();
  }

  create_sub_appointment() {
    if (this.service.id) {
      let body = {
        appointment_id: this.appointment.appointment.id,
        service_id: this.service.id,
        patient_id: this.appointment.patient.id,
        amount_due: this.service.final_price,
        is_paid: true,
        note: null
      }

      const sub = this.api.post("sub_appointments/", body, this.token).subscribe(
        async data => { },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong adding new service!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );

      sub.add(() => { this.get_appointment_id(this.appointment.appointment.id); })
    }
    else
      this.get_appointment_id(this.appointment.appointment.id);
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  print_invoice(payment_id: any) {
    this.router.navigate([]).then(result => { window.open('invoice_print?id=' + payment_id, '_blank'); });
  }

  print_note(notes: any) {
    localStorage.setItem('notes', JSON.stringify(notes));
    localStorage.setItem('patient', JSON.stringify(this.appointment?.patient));

    let app_details = {
      doctor: this.appointment.doctor.name,
      date: this.appointment.appointment.date,
      service: this.appointment?.appointment.service_name
    }

    localStorage.setItem('app_details', JSON.stringify(app_details));

    this.router.navigate([]).then(result => { window.open('print-notes', '_blank'); });
  }

  getHistoryNotes() {
    localStorage.setItem('patent_name', `${this.appointment?.patient.first_name} ${this.appointment?.patient.last_name}`)
    this.router.navigate([]).then(result => { window.open('history_notes_patient?id=' + this.appointment.patient.id, '_blank'); });
  }

  isDisabled() {
    if (this.utility.isDisabled(this.appointment?.appointment.service_name, this.hijama) ||
      this.package == null ||
      this.checkInstallmentValidity())
      return true;
    return false;
  }

  checkInstallmentValidity() {
    //   if (this.package.no_sessions_took < this.package.no_sessions) { this.invoice.payment_package = 'INSTALLMENT'; return true; }
    return false;
  }

  get_appointment_id(id: any) {
    const sub = this.api.get('appointments/' + id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.appointment = objects.appointments[0];
        this.applyPatientAge();
        localStorage.setItem('appointment', JSON.stringify(this.appointment));
      },
      async error => { }
    );

    sub.add(() => { this.get_sub_appointments(id); });
  }

  get_sub_appointments(id: any) {
    this.api.get(`sub_appointments/patient/${this.appointment.patient.id}/${id}`, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.sub_appointments = objects.sub_appointments;
      },
      async error => { }
    );
  }

  get_service_name(id: any) {
    if (id) {
      let service = this.services.find(i => i.id === id);

      if (service)
        return service.name;
    }
  }

  update_package() {
    let id = this.package.id;

    const body = {
      full_price: this.eidt_package.full_price
    }

    const sub = this.api.update("package_patients/full_price/" + id, body, this.token).subscribe(
      async data => {
        Swal.fire({
          title: 'Success!',
          text: 'updated Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    sub.add(() => { this.getPatientPackges(); this.modalService.dismissAll(); });
  }

  get_room(room: any) {
    const object = this.rooms.find(item => item.hasOwnProperty(room));
    return object ? object[room] : null;
  }

  get_room_label(room: any): string {
    const name = this.get_room(room);
    if (!name) return room || '—';
    return name.replace(/tratment room /i, 'Room ').replace(/treatment room /i, 'Room ');
  }

  get patientInitials(): string {
    const first = this.appointment?.patient?.first_name?.charAt(0) || '';
    const last = this.appointment?.patient?.last_name?.charAt(0) || '';
    return (first + last).toUpperCase();
  }

  statusBadgeClass(status: string): string {
    switch (status) {
      case 'COMPLETED':
        return 'status-badge status-completed';
      case 'CONFIRMED':
        return 'status-badge status-confirmed';
      case 'PENDING':
        return 'status-badge status-pending';
      case 'MISSED':
        return 'status-badge status-missed';
      case 'CANCELLED':
        return 'status-badge status-cancelled';
      default:
        return 'status-badge';
    }
  }

  sessionProgress(item: any): number {
    const total = Number(item?.no_sessions) || 0;
    if (!total) return 0;
    const taken = Number(item?.no_sessions_took) || 0;
    return Math.min(100, Math.round((taken / total) * 100));
  }

  allowed_to_close(appointment: any) {
    if (this.utility.isAdmin())
      return false;
    else {
      let now = new Date();
      let appointmentDate = new Date(appointment.date);

      // Set the time of both dates to midnight for accurate date comparison
      appointmentDate.setHours(21, 0, 0, 0);
      now.setHours(0, 0, 0, 0);

      // If the appointment date is before today, allow closing
      if (appointmentDate < now) {
        return true;
      }

      // Return false for appointments on the same day or in the future
      return false;
    }
  }
}
